import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableColumnEditorComponent } from './component/table-column-editor.component';
import { DictionaryModule } from '@sdbn/common';

import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule as MatCheckboxModule } from '@angular/material/checkbox';



@NgModule({
  declarations: [
    TableColumnEditorComponent
  ],
  exports: [
    TableColumnEditorComponent],
  imports: [
    CommonModule,

    DictionaryModule,
    CommonTranslationModule,
    CommonUIModule,
    DragDropModule,
    MatFormFieldModule,
    MatCheckboxModule
  ]
})
export class TableColumnEditorModule { }
